templates = require 'views/internal/templates'
View = require 'view'
t = require('views/internal/teacup-with-helpers')('select_member')

template = t.renderable ({ text, extraText, mentionCount }) ->
  t.li { class: 'item js-member-item' }, ->
    t.a { href: "#", class: 'js-select-member ', title: text, autocompleteText: text }, ->

      t.span '.text', title: "card", ->
        t.text "#{extraText} (#{mentionCount})"

module.exports = class SelectFilterableView extends View
  render: ->
    @$el.html(template(@options))

    @



// WEBPACK FOOTER //
// ./app/scripts/views/member/select-filterable-view.coffee